import { Skeleton } from "@mantine/core";
import { TransactionHistoryTable } from "@pages/Credits/components/TransactionHistoryTable";
import { Can, useAbility } from "@casl/react";
import { AbilityContext } from "@/Can";
import type { TransactionHistorySectionProps } from "../types";

/**
 * Transaction History Section Component
 *
 * Displays the transaction history table in the Return History tab.
 * Only visible to users with permission to view transaction history (owners).
 */
export const TransactionHistorySection = ({
  balanceHistory,
  membersList,
  isLoading,
}: TransactionHistorySectionProps) => {
  const ability = useAbility(AbilityContext);

  return (
    <Can I="view" a="TransactionHistoryTable" ability={ability}>
      {isLoading ? (
        <Skeleton height={300} />
      ) : (
        <TransactionHistoryTable
          balanceHistory={balanceHistory}
          membersList={membersList}
        />
      )}
    </Can>
  );
};
